<template>
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20.125"
      cy="20.5"
      r="19.125"
      stroke="url(#paint0_linear_1377_8897)"
      stroke-width="2"
    />
    <path
      d="M11.625 20.5L18 26.875L28.625 14.125"
      stroke="url(#paint1_linear_1377_8897)"
      stroke-width="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1377_8897"
        x1="17.4301"
        y1="-9.40454"
        x2="50.4847"
        y2="-1.14091"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1377_8897"
        x1="33.4159"
        y1="19.6017"
        x2="31.2954"
        y2="30.9109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
